var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplitedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68817 10.0248L2.27614 6.61277C1.75544 6.09207 0.911221 6.09207 0.390523 6.61277C-0.130174 7.13346 -0.130174 7.97768 0.390523 8.49838L4.83496 12.9428C5.38936 13.4972 6.30013 13.4559 6.80206 12.8536L15.6909 2.18694C16.1623 1.62124 16.0859 0.780489 15.5202 0.309071C14.9545 -0.162347 14.1138 -0.0859149 13.6423 0.479786L5.68817 10.0248Z",
    fill: "#10C101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplitedIcon);
export default __webpack_public_path__ + "static/media/complited-icon.667d2758c765afea4be06945264c33fa.svg";
export { ForwardRef as ReactComponent };